import * as constants from './Constants'

const BASE_URL = 'https://www.boots.com/webapp/wcs/stores/servlet/OrderItemAdd?URL=https%3A%2F%2Fwww.boots.com%2Fwebapp%2Fwcs%2Fstores%2Fservlet%2FOrderItemDisplay%3FURL%3DOrderItemDisplay%253ForderType%253Dregular%26storeId%3D11352%26orderType%3Dregular%26updatePrices%3D1%26calculationUsageId%3D-1%26langId%3D-1%26catalogId%3D28501&storeId=11352&catalogId=28501'
const STOCK_URL = 'https://www.boots.com/wcs/resources/store/11352/inventoryavailability/byPartNumber/'
const PROXY_URL = 'https://limitless-savannah-92654.herokuapp.com/'

// resolve has a parameter: true = known that we have stock; false = unknown - assume we do.
// reject has no parameters - only called if known out-of-stock condition.
export const checkStock = function (productIndex, number) {
  return (
    new Promise((resolve, reject) => {
      // Hard coded for now - will pull from list of product IDs when they are available.
      const productId = constants.PRODUCTS[productIndex].productid

      const url = `${PROXY_URL}${STOCK_URL}${productId}?responseFormat=json`

      fetch(url)
        .then(
          (response) => {
            if (response.status !== 200) {
              console.log(`Looks like there was a problem. Status Code: ${
                response.status}`)

              // no clear answer either way.  Assume in stock, but flag that we aren't sure by passing a
              // false parameter.
              resolve(false)
              return
            }

            // Examine the text in the response
            response.json().then((data) => {
              console.log(data)

              if (data.InventoryAvailability[0].availableQuantity >= number) {
              // we absolutely know we have this in stock
                resolve(true)
              }
              // we absolutely know we DON'T have this in stock
              else {
                reject()
              }
            })
          }
        )
        .catch((err) => {
          console.log('Fetch Error :-S', err)
          // no clear answer either way.  Assume in stock, but flag that we aren't sure by passing a
          // false parameter.
          resolve(false)
        })
    })
  )
}
/* unused
export function checkStockLevel(productIndex, unavailableCallback) {
  // Hard coded for now - will pull from list of product IDs when they are available.
  const productId = constants.PRODUCTS[productIndex].productid

  const url = `${PROXY_URL}${STOCK_URL}${productId}?responseFormat=json`

  fetch(url)
    .then(
      (response) => {
        if (response.status !== 200) {
          console.log(`Looks like there was a problem. Status Code: ${
            response.status}`)
          return
        }

        // Examine the text in the response
        response.json().then((data) => {
          console.log(data)

          if (data.InventoryAvailable[0].availableQuantity === 0) {
            unavailableCallback(productIndex, shade)
          }
        })
      }
    )
    .catch((err) => {
      console.log('Fetch Error :-S', err)
    })
} */

export function goToExternalCheckout(cartContents) {
  let url = `${BASE_URL}`
  let counter = 1

  
  cartContents.forEach((number, index) => {

    if (number > 0) {
      // something to buy
      const productId = constants.PRODUCTS[index].productid
      const catEntry = constants.PRODUCTS[index].catentry
      url += `&productid_${counter}=${productId}&catEntryId_${counter}=${catEntry}&quantity_${counter}=${number}`
      counter += 1
    }
  })

  // We have compiled the URL with the full order - now redirect to this URL.
  // Or rather, send a message to the parent iFrame to do so...
  window.top.postMessage(JSON.stringify({redirect: url}), '*')
  // (for working without iFrames, use: 
  // window.location.assign(url)

}

export const getProductStockLevel = function (productIndex) {
  return (
    new Promise((resolve, reject) => {
      const productId = constants.PRODUCTS[productIndex].productid

      const url = `${PROXY_URL}${STOCK_URL}${productId}?responseFormat=json`

      fetch(url)
        .then(
          (response) => {
            if (response.status !== 200) {
              console.log(`Looks like there was a problem. Status Code: ${
                response.status}`)

              // no clear answer either way.  Assume in stock, but flag that we aren't sure by passing a
              // false parameter.
              resolve(-1)
              return
            }

            // Examine the text in the response
            response.json().then((data) => {
              console.log(data)

              resolve(data.InventoryAvailability[0].availableQuantity)
            })
          }
        )
        .catch((err) => {
          console.log('Fetch Error :-S', err)
          // no clear answer either way.  Assume in stock, but flag that we aren't sure by passing a
          // false parameter.
          resolve(false)
        })
    })
  )
}
